import ContactUsRoutes from "./router/contact-router";

export default [ContactUsRoutes];